<template>
  <div class="grid gap-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1">
    <div
      v-for="(data, index) in dataAgent"
      :key="index"
      class="border w-full rounded-lg p-1 shadow-sm hover:shadow-md transition-shadow duration-200 flex flex-col"
    >
      <div class="flex-grow">
        <div class="flex items-center justify-between mb-1">
          <div class=" font-medium text-base">
            <span class="text-[#333333]">{{ data.name }}</span> - <span class="">{{ data.phone_number }}</span>
          </div>
          <div class="flex gap-2 items-center text-xs">
            <div :class="['w-2 h-2 rounded-full', data.is_active ? 'bg-green-500' : 'bg-red-500']" />
            <div>{{ data.is_active ? 'Aktif' : 'Tidak Aktif' }}</div>
          </div>
        </div>

        <div class="bg-[#F8F8F8] mt-2 grid grid-cols-1 md:grid-cols-6 items-start gap-3 border rounded-md p-1">
          <div class="md:col-span-2 flex justify-center items-center md:pr-3 py-0 md:py-0 relative">
            <div class="relative w-20 h-20">
              <!-- Gambar Pertama (Base layer) -->
              <b-img
                :src="data.products && data.products[0] && data.products[0].url ? data.products[0].url : 'https://storage.googleapis.com/komerce/assets/svg/default-image.svg'"
                alt="Product photo"
                class="rounded-md w-[4.5rem] h-[4.5rem] object-cover absolute top-0 left-0 z-10"
              />
              <!-- Gambar Kedua (Middle layer) -->
              <b-img
                v-if="data.products && data.products.length > 1"
                :src="data.products[1].url || 'https://storage.googleapis.com/komerce/assets/svg/default-image.svg'"
                alt="Product photo"
                class="rounded-md w-[4.5rem] h-[4.5rem] object-cover absolute top-1 left-1 z-20 border-2 border-white"
              />
              <!-- Gambar Ketiga + Counter (Top layer) -->
              <div
                v-if="data.products && data.products.length > 2"
                class="rounded-md w-[4.5rem] h-[4.5rem] bg-[#F4F4F4] bg-opacity-90 absolute top-2 left-2 z-30 flex items-center justify-center border-2 border-white"
              >
                <span class="text-xs font-medium text-[#333333]">+{{ data.products.length - 2 }}</span>
              </div>
            </div>
          </div>
          <div class="md:col-span-4 grid grid-cols-1 gap-y-2 text-sm">
            <div>
              <div class="flex">
                <div class="w-4/12 font-medium text-gray-600">
                  Jadwal
                </div>
                <div class="w-8/12">
                  : {{ data.times && data.times.length ? data.times.slice(0, 3).map(item => defineDay(item.day_of_week)).join(', ') + (data.times.length > 3 ? '...' : '') : 'Aktif Setiap Hari - (24/7)' }}
                  <b-icon
                    v-show="data.times && data.times.length"
                    :id="`popover-jadwal-${index}`"
                    class="cursor-pointer text-[#08A0F7] ml-[5px]"
                    icon="info-circle"
                  />
                  <b-popover
                    :target="`popover-jadwal-${index}`"
                    triggers="hover"
                    placement="top"
                    custom-class="custom-popover text-xs"
                  >
                    <div class="font-semibold">
                      Jadwal
                    </div>
                    <div v-if="data.times && data.times.length > 0">
                      <div
                        v-for="schedule in data.times"
                        :key="schedule.day"
                      >
                        {{ defineDay(schedule.day_of_week) }} : {{ schedule.start_time.substring(0,5) }} - {{ schedule.end_time.substring(0,5) }}
                      </div>
                    </div>
                  </b-popover>
                </div>
              </div>
            </div>
            <div>
              <div class="flex">
                <div class="w-4/12 font-medium text-gray-600">
                  Produk
                </div>
                <div class="w-8/12 truncate">
                  : {{ data.products && data.products.length > 0 ? data.products.filter(item => item.name).map(item => item.name).join(', ') || '-' : '-' }}
                </div>
              </div>
            </div>
            <div>
              <div class="flex">
                <div class="w-4/12 font-medium text-gray-600">
                  Nama Toko
                </div>
                <div class="w-8/12 truncate">
                  : {{ data.brand || '-' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex justify-end gap-1 mt-1  border-t border-gray-100">
        <b-button
          size="sm"
          variant="primary"
          class="!p-1 !px-[10px]"
          @click="handleEdit(data.id)"
        >
          Edit
        </b-button>
        <b-button
          :id="`popover-actions-${index}`"
          size="sm"
          class="!p-1 !px-[10px]"
          variant="outline-primary"
        >
          <b-icon icon="three-dots" />
        </b-button>
        <b-popover
          :target="`popover-actions-${index}`"
          triggers="focus"
          placement="bottomright"
          custom-class="custom-popover action-popover"
        >
          <div>
            <a
              href="#"
              class="block p-1 text-sm text-gray-700 hover:bg-gray-100 no-underline"
              @click="reActivateAgent(data.id, data.is_active)"
            >
              {{ data.is_active ? 'Nonaktifkan' : 'Aktifkan' }}
            </a>
          </div>
          <div class="border-t border-gray-100">
            <a
              href="#"
              class="block p-1 text-sm text-red-600 hover:bg-red-50 hover:text-red-700 no-underline"
              @click="deleteAgent(data.id)"
            >
              Hapus
            </a>
          </div>
        </b-popover>
      </div>
    </div>
  </div>
</template>

<script>
import { toast_error, toast_success } from '@/libs/toastification'
import { apiDeleteAgent, apiActivateAgent } from './service/api.agent.service'

export default {
  name: 'CardCsAi',
  props: {
    dataAgent: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const deleteAgent = async agentId => {
      try {
        await apiDeleteAgent(agentId)
        toast_success({ message: 'Berhasil menghapus agent' })
        emit('refresh')
      } catch (error) {
        toast_error({ message: error.message })
      }
    }
    const reActivateAgent = async (agentId, isActiv) => {
      const isActive = !isActiv
      try {
        await apiActivateAgent(agentId, isActive)
        emit('refresh')
        toast_success({ message: `Berhasil ${isActive ? 'mengaktifkan' : 'menonaktifkan'} agent` })
      } catch (error) {
        toast_error({ message: error.message })
      }
    }

    return {
      deleteAgent,
      reActivateAgent,
    }
  },
  methods: {
    defineDay(day) {
      const dayMap = {
        monday: 'Senin',
        tuesday: 'Selasa',
        wednesday: 'Rabu',
        thursday: 'Kamis',
        friday: 'Jumat',
        saturday: 'Sabtu',
        sunday: 'Minggu',
      }

      return dayMap[day] || '-'
    },
    handleEdit(agentId) {
      this.$router.push({
        name: 'edit-ai-customer-service',
        params: { id: agentId },
      })
    },
  },
}
</script>

<style>
.custom-popover {
  padding: 0;
  border-radius: 0.375rem; /* 6px */
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  min-width: 150px; /* Atur lebar minimum jika perlu */
}
.custom-popover .popover-header {
  font-size: 0.875rem; /* 14px */
  padding: 0.5rem 0.75rem; /* 8px 12px */
  border-bottom: 1px solid #f0f0f0;
}
.custom-popover .popover-body {
  padding: 0.5rem 0.75rem; /* 8px 12px */
  font-size: 0.875rem; /* 14px */
}

/* Khusus untuk popover aksi agar tidak ada padding default dari b-popover */
.action-popover .popover-body {
  padding: 0;
}

.no-underline {
  text-decoration: none !important;
}
</style>
